import * as React from 'react';
import {
    BooleanField,
    BooleanInput,
    Create,
    Edit,
    EditButton,
    List,
    NumberField,
    NumberInput,
    required,
    SimpleForm,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';

const filters = [
    <TextInput source="all" label="Recherche" alwaysOn />,
];

const parseFeatures = (value: string) =>
    typeof value === 'string'
        ? value.split('\n').map((item) => item.trim()).filter(Boolean)
        : value;

const formatFeatures = (value: string[]) =>
    Array.isArray(value) ? value.join('\n') : '';

const OfferForm = () => (
    <>
        <TextInput source="name" label="Nom" validate={required()} fullWidth />
        <TextInput source="slug" label="Identifiant" validate={required()} />
        <NumberInput source="price" label="Prix (€)" validate={required()} />
        <NumberInput
            source="deposit_amount"
            label="Caution bancaire (€)"
            defaultValue={0}
            validate={required()}
        />
        <TextInput
            source="features"
            label="Prestations incluses — une par ligne"
            multiline
            rows={5}
            fullWidth
            parse={parseFeatures}
            format={formatFeatures}
        />
        <BooleanInput source="active" label="Active" defaultValue={true} />
        <NumberInput source="position" label="Position" validate={required()} />
    </>
);

export const BoxOfferList = (props) => (
    <List
        {...props}
        filters={filters}
        bulkActionButtons={false}
        sort={{ field: 'position', order: 'ASC' }}
        perPage={50}
        pagination={<AdminPagination />}
        exporter={false}
    >
        <AdminSelectableDatagrid>
            <NumberField source="position" label="#" />
            <TextField source="name" label="Offre" />
            <NumberField source="price" label="Prix (€)" options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }} />
            <BooleanField source="active" label="Active" />
            <EditButton />
            <HumanDeleteButton fields={["name"]} fallback="cette offre" />
        </AdminSelectableDatagrid>
    </List>
);

export const BoxOfferEdit = (props) => (
    <Edit {...props} mutationMode="optimistic" title={<HumanRecordTitle fields={["name"]} fallback="Offre Box" />}>
        <SimpleForm redirect="list">
            <OfferForm />
        </SimpleForm>
    </Edit>
);

export const BoxOfferCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <OfferForm />
        </SimpleForm>
    </Create>
);
